angular.module('cian.advancedBrowser')
  .directive('advancedSection', [() => {
    return {
      restrict: 'A',
      template: (elem, attrs) => require(`../../templates/sections/${attrs.advancedSection}.html`),
    };
  }]);



// WEBPACK FOOTER //
// ./src/components/advanced-browser/src/scripts/cian.advanced-browser-section.dir.js